import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LocaleEnum } from '@systemeio/ui';
import { AutomationsIcon, BlogsIcon, ContactsIcon, DashboardIcon, EmailsIcon, HelpIcon, ManInSuit, ProductsIcon, SalesIcon, SmsMenuIcon, UpgradeIcon } from '@systemeio/ui/icons';
import { isClient, isSioHost } from '@systemeio/util';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { AdminRolesEnum } from 'shared/enums/user-roles-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { formUrl } from 'shared/utils/links/form-url';
import { MenuItemType } from '../types/menu-interface';
import { useRouter } from 'next/router';
export const useMenuItems = () => {
  const $ = _c(433);
  const {
    t
  } = useLocoTranslation();
  const {
    checkAdminRoles,
    user,
    isWorkspaceOwner,
    isSubAccountImpersonation,
    isSupportImpersonation,
    isWsAssistant,
    isCustomer,
    isAffiliate,
    isStudent,
    isWsAdmin
  } = useUser();
  const websiteFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.Website);
  const whiteLabelFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.WhiteLabel);
  let t0;
  if ($[0] !== checkAdminRoles) {
    t0 = checkAdminRoles([AdminRolesEnum.support, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[0] = checkAdminRoles;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isRegularAdmin = t0;
  const {
    pathname
  } = useRouter();
  let t1;
  if ($[2] !== pathname) {
    t1 = url => pathname.includes(url);
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const regularIsActiveCheck = t1;
  const t2 = user?.userPlanId === 40 && isWorkspaceOwner && !isSupportImpersonation;
  let t3;
  if ($[4] !== t) {
    t3 = t("header.top_menu.upgrade");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== regularIsActiveCheck || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      href: "/profile/user-plan",
      shouldRender: t2,
      mobileIconRenderer: _temp,
      name: t3,
      isActive: regularIsActiveCheck
    };
    $[6] = regularIsActiveCheck;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("header.top_menu.dashboard");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("header.top_menu.main_dashboard");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = (isWorkspaceOwner || isWsAdmin) && isCustomer;
  let t8;
  if ($[14] !== pathname) {
    t8 = url_0 => pathname === url_0;
    $[14] = pathname;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      name: t6,
      href: "/",
      shouldRender: t7,
      isActive: t8
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("header.top_menu.affiliate_dashboard");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = isWorkspaceOwner && isAffiliate;
  let t12;
  if ($[22] !== regularIsActiveCheck || $[23] !== t10 || $[24] !== t11) {
    t12 = {
      name: t10,
      href: "/affiliate-dashboard",
      shouldRender: t11,
      isActive: regularIsActiveCheck
    };
    $[22] = regularIsActiveCheck;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("header.top_menu.student_dashboard");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== isStudent) {
    t14 = isStudent ? formUrl("/school", false) ?? "" : formUrl("/school?tab=explore_courses", false) ?? "";
    $[28] = isStudent;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isStudent || $[31] !== regularIsActiveCheck || $[32] !== t13 || $[33] !== t14) {
    t15 = {
      name: t13,
      shouldRender: isStudent,
      href: t14,
      isActive: regularIsActiveCheck
    };
    $[30] = isStudent;
    $[31] = regularIsActiveCheck;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("header.top_menu.agency_dashboard");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  bb0: {
    if (!whiteLabelFeatureIsOn) {
      t17 = false;
      break bb0;
    }
    if (isSubAccountImpersonation) {
      t17 = false;
      break bb0;
    }
    if (!isCustomer) {
      t17 = false;
      break bb0;
    }
    if (!isWorkspaceOwner) {
      t17 = false;
      break bb0;
    }
    if (!isClient()) {
      t17 = false;
      break bb0;
    }
    let t18;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = isSioHost(window.location.host);
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    t17 = t18;
  }
  let t18;
  if ($[38] !== pathname) {
    t18 = () => pathname.includes("/agency-center");
    $[38] = pathname;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t16 || $[41] !== t17 || $[42] !== t18) {
    t19 = {
      name: t16,
      href: "/agency-center/white-label-users",
      shouldRender: t17,
      isActive: t18
    };
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t12 || $[45] !== t15 || $[46] !== t19 || $[47] !== t9) {
    t20 = [t9, t12, t15, t19];
    $[44] = t12;
    $[45] = t15;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20 || $[50] !== t5) {
    t21 = {
      name: t5,
      dropdownItems: t20,
      mobileIconRenderer: _temp2
    };
    $[49] = t20;
    $[50] = t5;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t) {
    t22 = t("header.top_menu.crm");
    $[52] = t;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t) {
    t23 = t("header.top_menu.contacts");
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  const t24 = isWsAssistant ? "/assistant/contacts" : "/contacts";
  let t25;
  if ($[56] !== isCustomer || $[57] !== regularIsActiveCheck || $[58] !== t23 || $[59] !== t24) {
    t25 = {
      name: t23,
      href: t24,
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[56] = isCustomer;
    $[57] = regularIsActiveCheck;
    $[58] = t23;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t) {
    t26 = t("header.top_menu.tags");
    $[61] = t;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== isCustomer || $[64] !== regularIsActiveCheck || $[65] !== t26) {
    t27 = {
      name: t26,
      href: "/tags",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[63] = isCustomer;
    $[64] = regularIsActiveCheck;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t) {
    t28 = t("header.top_menu.crm_pipeline");
    $[67] = t;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== isCustomer || $[70] !== regularIsActiveCheck || $[71] !== t28) {
    t29 = {
      name: t28,
      href: "/crm-pipeline",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[69] = isCustomer;
    $[70] = regularIsActiveCheck;
    $[71] = t28;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== t) {
    t30 = t("header.top_menu.calendar");
    $[73] = t;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== isCustomer || $[76] !== regularIsActiveCheck || $[77] !== t30) {
    t31 = {
      name: t30,
      href: "/calendar",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[75] = isCustomer;
    $[76] = regularIsActiveCheck;
    $[77] = t30;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t25 || $[80] !== t27 || $[81] !== t29 || $[82] !== t31) {
    t32 = [t25, t27, t29, t31];
    $[79] = t25;
    $[80] = t27;
    $[81] = t29;
    $[82] = t31;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t22 || $[85] !== t32) {
    t33 = {
      name: t22,
      dropdownItems: t32,
      mobileIconRenderer: _temp3
    };
    $[84] = t22;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t) {
    t34 = t("header.top_menu.sites");
    $[87] = t;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  if ($[89] !== t) {
    t35 = t("header.top_menu.website");
    $[89] = t;
    $[90] = t35;
  } else {
    t35 = $[90];
  }
  const t36 = isCustomer && websiteFeatureIsOn;
  let t37;
  if ($[91] !== regularIsActiveCheck || $[92] !== t35 || $[93] !== t36) {
    t37 = {
      name: t35,
      href: "/websites",
      shouldRender: t36,
      isActive: regularIsActiveCheck
    };
    $[91] = regularIsActiveCheck;
    $[92] = t35;
    $[93] = t36;
    $[94] = t37;
  } else {
    t37 = $[94];
  }
  let t38;
  if ($[95] !== t) {
    t38 = t("header.top_menu.funnels");
    $[95] = t;
    $[96] = t38;
  } else {
    t38 = $[96];
  }
  let t39;
  if ($[97] !== isCustomer || $[98] !== regularIsActiveCheck || $[99] !== t38) {
    t39 = {
      name: t38,
      href: "/funnels",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[97] = isCustomer;
    $[98] = regularIsActiveCheck;
    $[99] = t38;
    $[100] = t39;
  } else {
    t39 = $[100];
  }
  let t40;
  if ($[101] !== t) {
    t40 = t("header.top_menu.digital_stores");
    $[101] = t;
    $[102] = t40;
  } else {
    t40 = $[102];
  }
  let t41;
  if ($[103] !== isCustomer || $[104] !== regularIsActiveCheck || $[105] !== t40) {
    t41 = {
      name: t40,
      href: "/stores",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[103] = isCustomer;
    $[104] = regularIsActiveCheck;
    $[105] = t40;
    $[106] = t41;
  } else {
    t41 = $[106];
  }
  let t42;
  if ($[107] !== t) {
    t42 = t("header.top_menu.blogs");
    $[107] = t;
    $[108] = t42;
  } else {
    t42 = $[108];
  }
  let t43;
  if ($[109] !== isCustomer || $[110] !== regularIsActiveCheck || $[111] !== t42) {
    t43 = {
      name: t42,
      href: "/blogs",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[109] = isCustomer;
    $[110] = regularIsActiveCheck;
    $[111] = t42;
    $[112] = t43;
  } else {
    t43 = $[112];
  }
  let t44;
  if ($[113] !== t37 || $[114] !== t39 || $[115] !== t41 || $[116] !== t43) {
    t44 = [t37, t39, t41, t43];
    $[113] = t37;
    $[114] = t39;
    $[115] = t41;
    $[116] = t43;
    $[117] = t44;
  } else {
    t44 = $[117];
  }
  let t45;
  if ($[118] !== t34 || $[119] !== t44) {
    t45 = {
      name: t34,
      dropdownItems: t44,
      mobileIconRenderer: _temp4
    };
    $[118] = t34;
    $[119] = t44;
    $[120] = t45;
  } else {
    t45 = $[120];
  }
  let t46;
  if ($[121] !== t) {
    t46 = t("header.top_menu.emails");
    $[121] = t;
    $[122] = t46;
  } else {
    t46 = $[122];
  }
  let t47;
  if ($[123] !== t) {
    t47 = t("header.top_menu.newsletters");
    $[123] = t;
    $[124] = t47;
  } else {
    t47 = $[124];
  }
  let t48;
  if ($[125] !== isCustomer || $[126] !== regularIsActiveCheck || $[127] !== t47) {
    t48 = {
      name: t47,
      href: "/newsletters",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[125] = isCustomer;
    $[126] = regularIsActiveCheck;
    $[127] = t47;
    $[128] = t48;
  } else {
    t48 = $[128];
  }
  let t49;
  if ($[129] !== t) {
    t49 = t("header.top_menu.campaigns");
    $[129] = t;
    $[130] = t49;
  } else {
    t49 = $[130];
  }
  let t50;
  if ($[131] !== isCustomer || $[132] !== regularIsActiveCheck || $[133] !== t49) {
    t50 = {
      name: t49,
      href: "/campaigns",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[131] = isCustomer;
    $[132] = regularIsActiveCheck;
    $[133] = t49;
    $[134] = t50;
  } else {
    t50 = $[134];
  }
  let t51;
  if ($[135] !== t) {
    t51 = t("header.top_menu.email_statistics");
    $[135] = t;
    $[136] = t51;
  } else {
    t51 = $[136];
  }
  let t52;
  if ($[137] !== isCustomer || $[138] !== regularIsActiveCheck || $[139] !== t51) {
    t52 = {
      name: t51,
      href: "/email-statistics",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[137] = isCustomer;
    $[138] = regularIsActiveCheck;
    $[139] = t51;
    $[140] = t52;
  } else {
    t52 = $[140];
  }
  let t53;
  if ($[141] !== t48 || $[142] !== t50 || $[143] !== t52) {
    t53 = [t48, t50, t52];
    $[141] = t48;
    $[142] = t50;
    $[143] = t52;
    $[144] = t53;
  } else {
    t53 = $[144];
  }
  let t54;
  if ($[145] !== t46 || $[146] !== t53) {
    t54 = {
      name: t46,
      dropdownItems: t53,
      mobileIconRenderer: _temp5
    };
    $[145] = t46;
    $[146] = t53;
    $[147] = t54;
  } else {
    t54 = $[147];
  }
  let t55;
  if ($[148] !== t) {
    t55 = t("header.top_menu.sms");
    $[148] = t;
    $[149] = t55;
  } else {
    t55 = $[149];
  }
  let t56;
  if ($[150] !== t) {
    t56 = t("header.top_menu.sms_templates");
    $[150] = t;
    $[151] = t56;
  } else {
    t56 = $[151];
  }
  let t57;
  if ($[152] !== isCustomer || $[153] !== regularIsActiveCheck || $[154] !== t56) {
    t57 = {
      name: t56,
      href: "/sms/templates",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[152] = isCustomer;
    $[153] = regularIsActiveCheck;
    $[154] = t56;
    $[155] = t57;
  } else {
    t57 = $[155];
  }
  let t58;
  if ($[156] !== t) {
    t58 = t("header.top_menu.sms_statistics");
    $[156] = t;
    $[157] = t58;
  } else {
    t58 = $[157];
  }
  let t59;
  if ($[158] !== isCustomer || $[159] !== regularIsActiveCheck || $[160] !== t58) {
    t59 = {
      name: t58,
      href: "/sms/statistics",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[158] = isCustomer;
    $[159] = regularIsActiveCheck;
    $[160] = t58;
    $[161] = t59;
  } else {
    t59 = $[161];
  }
  let t60;
  if ($[162] !== t57 || $[163] !== t59) {
    t60 = [t57, t59];
    $[162] = t57;
    $[163] = t59;
    $[164] = t60;
  } else {
    t60 = $[164];
  }
  let t61;
  if ($[165] !== t55 || $[166] !== t60) {
    t61 = {
      name: t55,
      dropdownItems: t60,
      mobileIconRenderer: _temp6
    };
    $[165] = t55;
    $[166] = t60;
    $[167] = t61;
  } else {
    t61 = $[167];
  }
  let t62;
  if ($[168] !== t) {
    t62 = t("header.top_menu.automations");
    $[168] = t;
    $[169] = t62;
  } else {
    t62 = $[169];
  }
  let t63;
  if ($[170] !== t) {
    t63 = t("header.top_menu.rules");
    $[170] = t;
    $[171] = t63;
  } else {
    t63 = $[171];
  }
  let t64;
  if ($[172] !== isCustomer || $[173] !== regularIsActiveCheck || $[174] !== t63) {
    t64 = {
      name: t63,
      href: "/automation-rules",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[172] = isCustomer;
    $[173] = regularIsActiveCheck;
    $[174] = t63;
    $[175] = t64;
  } else {
    t64 = $[175];
  }
  let t65;
  if ($[176] !== t) {
    t65 = t("header.top_menu.workflows");
    $[176] = t;
    $[177] = t65;
  } else {
    t65 = $[177];
  }
  let t66;
  if ($[178] !== isCustomer || $[179] !== regularIsActiveCheck || $[180] !== t65) {
    t66 = {
      name: t65,
      href: "/workflows",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[178] = isCustomer;
    $[179] = regularIsActiveCheck;
    $[180] = t65;
    $[181] = t66;
  } else {
    t66 = $[181];
  }
  let t67;
  if ($[182] !== t64 || $[183] !== t66) {
    t67 = [t64, t66];
    $[182] = t64;
    $[183] = t66;
    $[184] = t67;
  } else {
    t67 = $[184];
  }
  let t68;
  if ($[185] !== t62 || $[186] !== t67) {
    t68 = {
      name: t62,
      dropdownItems: t67,
      mobileIconRenderer: _temp7
    };
    $[185] = t62;
    $[186] = t67;
    $[187] = t68;
  } else {
    t68 = $[187];
  }
  let t69;
  if ($[188] !== t) {
    t69 = t("header.top_menu.products");
    $[188] = t;
    $[189] = t69;
  } else {
    t69 = $[189];
  }
  let t70;
  if ($[190] !== t) {
    t70 = t("header.top_menu.physical_product");
    $[190] = t;
    $[191] = t70;
  } else {
    t70 = $[191];
  }
  let t71;
  if ($[192] !== isCustomer || $[193] !== regularIsActiveCheck || $[194] !== t70) {
    t71 = {
      name: t70,
      href: "/products",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[192] = isCustomer;
    $[193] = regularIsActiveCheck;
    $[194] = t70;
    $[195] = t71;
  } else {
    t71 = $[195];
  }
  let t72;
  if ($[196] !== t) {
    t72 = t("header.top_menu.coupons");
    $[196] = t;
    $[197] = t72;
  } else {
    t72 = $[197];
  }
  let t73;
  if ($[198] !== isCustomer || $[199] !== regularIsActiveCheck || $[200] !== t72) {
    t73 = {
      name: t72,
      href: "/coupons",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[198] = isCustomer;
    $[199] = regularIsActiveCheck;
    $[200] = t72;
    $[201] = t73;
  } else {
    t73 = $[201];
  }
  let t74;
  if ($[202] !== t) {
    t74 = t("header.top_menu.courses");
    $[202] = t;
    $[203] = t74;
  } else {
    t74 = $[203];
  }
  let t75;
  if ($[204] !== isCustomer || $[205] !== regularIsActiveCheck || $[206] !== t74) {
    t75 = {
      name: t74,
      href: "/courses",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[204] = isCustomer;
    $[205] = regularIsActiveCheck;
    $[206] = t74;
    $[207] = t75;
  } else {
    t75 = $[207];
  }
  let t76;
  if ($[208] !== t) {
    t76 = t("header.top_menu.communities");
    $[208] = t;
    $[209] = t76;
  } else {
    t76 = $[209];
  }
  let t77;
  if ($[210] !== isCustomer || $[211] !== regularIsActiveCheck || $[212] !== t76) {
    t77 = {
      name: t76,
      href: "/communities",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[210] = isCustomer;
    $[211] = regularIsActiveCheck;
    $[212] = t76;
    $[213] = t77;
  } else {
    t77 = $[213];
  }
  let t78;
  if ($[214] !== t) {
    t78 = t("header.top_menu.files");
    $[214] = t;
    $[215] = t78;
  } else {
    t78 = $[215];
  }
  let t79;
  if ($[216] !== isCustomer || $[217] !== regularIsActiveCheck || $[218] !== t78) {
    t79 = {
      name: t78,
      href: "/files",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[216] = isCustomer;
    $[217] = regularIsActiveCheck;
    $[218] = t78;
    $[219] = t79;
  } else {
    t79 = $[219];
  }
  let t80;
  if ($[220] !== t71 || $[221] !== t73 || $[222] !== t75 || $[223] !== t77 || $[224] !== t79) {
    t80 = [t71, t73, t75, t77, t79];
    $[220] = t71;
    $[221] = t73;
    $[222] = t75;
    $[223] = t77;
    $[224] = t79;
    $[225] = t80;
  } else {
    t80 = $[225];
  }
  let t81;
  if ($[226] !== t69 || $[227] !== t80) {
    t81 = {
      name: t69,
      dropdownItems: t80,
      mobileIconRenderer: _temp8
    };
    $[226] = t69;
    $[227] = t80;
    $[228] = t81;
  } else {
    t81 = $[228];
  }
  let t82;
  if ($[229] !== t) {
    t82 = t("header.top_menu.sales");
    $[229] = t;
    $[230] = t82;
  } else {
    t82 = $[230];
  }
  let t83;
  if ($[231] !== t) {
    t83 = t("header.top_menu.orders");
    $[231] = t;
    $[232] = t83;
  } else {
    t83 = $[232];
  }
  let t84;
  if ($[233] !== isCustomer || $[234] !== regularIsActiveCheck || $[235] !== t83) {
    t84 = {
      name: t83,
      href: "/orders",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[233] = isCustomer;
    $[234] = regularIsActiveCheck;
    $[235] = t83;
    $[236] = t84;
  } else {
    t84 = $[236];
  }
  let t85;
  if ($[237] !== t) {
    t85 = t("header.top_menu.transactions");
    $[237] = t;
    $[238] = t85;
  } else {
    t85 = $[238];
  }
  let t86;
  if ($[239] !== isCustomer || $[240] !== regularIsActiveCheck || $[241] !== t85) {
    t86 = {
      name: t85,
      href: "/payment/transactions",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[239] = isCustomer;
    $[240] = regularIsActiveCheck;
    $[241] = t85;
    $[242] = t86;
  } else {
    t86 = $[242];
  }
  let t87;
  if ($[243] !== t) {
    t87 = t("header.top_menu.subscriptions");
    $[243] = t;
    $[244] = t87;
  } else {
    t87 = $[244];
  }
  let t88;
  if ($[245] !== isCustomer || $[246] !== regularIsActiveCheck || $[247] !== t87) {
    t88 = {
      name: t87,
      href: "/payment/subscriptions",
      isActive: regularIsActiveCheck,
      shouldRender: isCustomer
    };
    $[245] = isCustomer;
    $[246] = regularIsActiveCheck;
    $[247] = t87;
    $[248] = t88;
  } else {
    t88 = $[248];
  }
  let t89;
  if ($[249] !== t) {
    t89 = t("header.top_menu.affiliate_invoices");
    $[249] = t;
    $[250] = t89;
  } else {
    t89 = $[250];
  }
  let t90;
  bb1: {
    if (isWsAssistant) {
      t90 = false;
      break bb1;
    }
    if (!isClient()) {
      t90 = false;
      break bb1;
    }
    let t91;
    if ($[251] === Symbol.for("react.memo_cache_sentinel")) {
      t91 = isSioHost(window.location.host);
      $[251] = t91;
    } else {
      t91 = $[251];
    }
    t90 = t91;
  }
  let t91;
  if ($[252] !== regularIsActiveCheck || $[253] !== t89 || $[254] !== t90) {
    t91 = {
      name: t89,
      href: "/payment/affiliate-invoices",
      shouldRender: t90,
      isActive: regularIsActiveCheck
    };
    $[252] = regularIsActiveCheck;
    $[253] = t89;
    $[254] = t90;
    $[255] = t91;
  } else {
    t91 = $[255];
  }
  let t92;
  if ($[256] !== t) {
    t92 = t("header.top_menu.affiliate_program");
    $[256] = t;
    $[257] = t92;
  } else {
    t92 = $[257];
  }
  let t93;
  bb2: {
    if (!isWorkspaceOwner) {
      t93 = false;
      break bb2;
    }
    if (!isClient()) {
      t93 = false;
      break bb2;
    }
    let t94;
    if ($[258] === Symbol.for("react.memo_cache_sentinel")) {
      t94 = isSioHost(window.location.host);
      $[258] = t94;
    } else {
      t94 = $[258];
    }
    t93 = t94;
  }
  let t94;
  if ($[259] !== regularIsActiveCheck || $[260] !== t92 || $[261] !== t93) {
    t94 = {
      name: t92,
      href: "/affiliate-program",
      shouldRender: t93,
      isActive: regularIsActiveCheck
    };
    $[259] = regularIsActiveCheck;
    $[260] = t92;
    $[261] = t93;
    $[262] = t94;
  } else {
    t94 = $[262];
  }
  let t95;
  if ($[263] !== t84 || $[264] !== t86 || $[265] !== t88 || $[266] !== t91 || $[267] !== t94) {
    t95 = [t84, t86, t88, t91, t94];
    $[263] = t84;
    $[264] = t86;
    $[265] = t88;
    $[266] = t91;
    $[267] = t94;
    $[268] = t95;
  } else {
    t95 = $[268];
  }
  let t96;
  if ($[269] !== t82 || $[270] !== t95) {
    t96 = {
      name: t82,
      dropdownItems: t95,
      mobileIconRenderer: _temp9
    };
    $[269] = t82;
    $[270] = t95;
    $[271] = t96;
  } else {
    t96 = $[271];
  }
  let t97;
  if ($[272] !== t) {
    t97 = t("header.top_menu.admin.admin");
    $[272] = t;
    $[273] = t97;
  } else {
    t97 = $[273];
  }
  let t98;
  if ($[274] !== t) {
    t98 = t("header.top_menu.admin.users");
    $[274] = t;
    $[275] = t98;
  } else {
    t98 = $[275];
  }
  let t99;
  if ($[276] !== isRegularAdmin || $[277] !== regularIsActiveCheck || $[278] !== t98) {
    t99 = {
      name: t98,
      href: "/management/users",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[276] = isRegularAdmin;
    $[277] = regularIsActiveCheck;
    $[278] = t98;
    $[279] = t99;
  } else {
    t99 = $[279];
  }
  let t100;
  if ($[280] !== t) {
    t100 = t("header.top_menu.admin.templates");
    $[280] = t;
    $[281] = t100;
  } else {
    t100 = $[281];
  }
  let t101;
  if ($[282] !== t) {
    t101 = t("header.top_menu.admin.email_templates");
    $[282] = t;
    $[283] = t101;
  } else {
    t101 = $[283];
  }
  let t102;
  if ($[284] !== checkAdminRoles) {
    t102 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[284] = checkAdminRoles;
    $[285] = t102;
  } else {
    t102 = $[285];
  }
  let t103;
  if ($[286] !== regularIsActiveCheck || $[287] !== t101 || $[288] !== t102) {
    t103 = {
      name: t101,
      href: "/management/email-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t102
    };
    $[286] = regularIsActiveCheck;
    $[287] = t101;
    $[288] = t102;
    $[289] = t103;
  } else {
    t103 = $[289];
  }
  let t104;
  if ($[290] !== t) {
    t104 = t("header.top_menu.admin.page_templates");
    $[290] = t;
    $[291] = t104;
  } else {
    t104 = $[291];
  }
  let t105;
  if ($[292] !== checkAdminRoles) {
    t105 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[292] = checkAdminRoles;
    $[293] = t105;
  } else {
    t105 = $[293];
  }
  let t106;
  if ($[294] !== regularIsActiveCheck || $[295] !== t104 || $[296] !== t105) {
    t106 = {
      name: t104,
      href: "/management/page-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t105
    };
    $[294] = regularIsActiveCheck;
    $[295] = t104;
    $[296] = t105;
    $[297] = t106;
  } else {
    t106 = $[297];
  }
  let t107;
  if ($[298] !== t) {
    t107 = t("header.top_menu.admin.blog_templates");
    $[298] = t;
    $[299] = t107;
  } else {
    t107 = $[299];
  }
  let t108;
  if ($[300] !== checkAdminRoles) {
    t108 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[300] = checkAdminRoles;
    $[301] = t108;
  } else {
    t108 = $[301];
  }
  let t109;
  if ($[302] !== regularIsActiveCheck || $[303] !== t107 || $[304] !== t108) {
    t109 = {
      name: t107,
      href: "/management/blog-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t108
    };
    $[302] = regularIsActiveCheck;
    $[303] = t107;
    $[304] = t108;
    $[305] = t109;
  } else {
    t109 = $[305];
  }
  let t110;
  if ($[306] !== t) {
    t110 = t("header.top_menu.admin.website_templates");
    $[306] = t;
    $[307] = t110;
  } else {
    t110 = $[307];
  }
  let t111;
  if ($[308] !== checkAdminRoles || $[309] !== websiteFeatureIsOn) {
    t111 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]) && websiteFeatureIsOn;
    $[308] = checkAdminRoles;
    $[309] = websiteFeatureIsOn;
    $[310] = t111;
  } else {
    t111 = $[310];
  }
  let t112;
  if ($[311] !== regularIsActiveCheck || $[312] !== t110 || $[313] !== t111) {
    t112 = {
      name: t110,
      href: "/management/website-templates",
      shouldRender: t111,
      isActive: regularIsActiveCheck
    };
    $[311] = regularIsActiveCheck;
    $[312] = t110;
    $[313] = t111;
    $[314] = t112;
  } else {
    t112 = $[314];
  }
  let t113;
  if ($[315] !== t) {
    t113 = t("header.top_menu.admin.funnel_templates");
    $[315] = t;
    $[316] = t113;
  } else {
    t113 = $[316];
  }
  let t114;
  if ($[317] !== checkAdminRoles) {
    t114 = checkAdminRoles([AdminRolesEnum.contentManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin]);
    $[317] = checkAdminRoles;
    $[318] = t114;
  } else {
    t114 = $[318];
  }
  let t115;
  if ($[319] !== regularIsActiveCheck || $[320] !== t113 || $[321] !== t114) {
    t115 = {
      name: t113,
      href: "/management/funnel-templates",
      isActive: regularIsActiveCheck,
      shouldRender: t114
    };
    $[319] = regularIsActiveCheck;
    $[320] = t113;
    $[321] = t114;
    $[322] = t115;
  } else {
    t115 = $[322];
  }
  let t116;
  if ($[323] !== t103 || $[324] !== t106 || $[325] !== t109 || $[326] !== t112 || $[327] !== t115) {
    t116 = [t103, t106, t109, t112, t115];
    $[323] = t103;
    $[324] = t106;
    $[325] = t109;
    $[326] = t112;
    $[327] = t115;
    $[328] = t116;
  } else {
    t116 = $[328];
  }
  let t117;
  if ($[329] !== t100 || $[330] !== t116) {
    t117 = {
      name: t100,
      dropdownItems: t116
    };
    $[329] = t100;
    $[330] = t116;
    $[331] = t117;
  } else {
    t117 = $[331];
  }
  let t118;
  if ($[332] !== t) {
    t118 = t("header.top_menu.admin.customers");
    $[332] = t;
    $[333] = t118;
  } else {
    t118 = $[333];
  }
  let t119;
  if ($[334] !== checkAdminRoles) {
    t119 = checkAdminRoles([AdminRolesEnum.mailingManager, AdminRolesEnum.admin, AdminRolesEnum.superAdmin, AdminRolesEnum.support]);
    $[334] = checkAdminRoles;
    $[335] = t119;
  } else {
    t119 = $[335];
  }
  let t120;
  if ($[336] !== regularIsActiveCheck || $[337] !== t118 || $[338] !== t119) {
    t120 = {
      name: t118,
      href: "/management/user-customer-list",
      shouldRender: t119,
      isActive: regularIsActiveCheck
    };
    $[336] = regularIsActiveCheck;
    $[337] = t118;
    $[338] = t119;
    $[339] = t120;
  } else {
    t120 = $[339];
  }
  let t121;
  if ($[340] !== t) {
    t121 = t("header.top_menu.admin.emails");
    $[340] = t;
    $[341] = t121;
  } else {
    t121 = $[341];
  }
  let t122;
  if ($[342] !== isRegularAdmin || $[343] !== regularIsActiveCheck || $[344] !== t121) {
    t122 = {
      name: t121,
      href: "/management/emails-delivery-statistics",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[342] = isRegularAdmin;
    $[343] = regularIsActiveCheck;
    $[344] = t121;
    $[345] = t122;
  } else {
    t122 = $[345];
  }
  let t123;
  if ($[346] !== t) {
    t123 = t("header.top_menu.admin.user_plans");
    $[346] = t;
    $[347] = t123;
  } else {
    t123 = $[347];
  }
  const t124 = !isWsAssistant && isRegularAdmin;
  let t125;
  if ($[348] !== regularIsActiveCheck || $[349] !== t123 || $[350] !== t124) {
    t125 = {
      name: t123,
      href: "/management/user-plans",
      shouldRender: t124,
      isActive: regularIsActiveCheck
    };
    $[348] = regularIsActiveCheck;
    $[349] = t123;
    $[350] = t124;
    $[351] = t125;
  } else {
    t125 = $[351];
  }
  let t126;
  if ($[352] !== t) {
    t126 = t("header.top_menu.admin.domains_blocked");
    $[352] = t;
    $[353] = t126;
  } else {
    t126 = $[353];
  }
  let t127;
  if ($[354] !== isRegularAdmin || $[355] !== regularIsActiveCheck || $[356] !== t126) {
    t127 = {
      name: t126,
      href: "/management/blocked-mailbox-provider",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[354] = isRegularAdmin;
    $[355] = regularIsActiveCheck;
    $[356] = t126;
    $[357] = t127;
  } else {
    t127 = $[357];
  }
  let t128;
  if ($[358] !== t) {
    t128 = t("header.top_menu.admin.domains_white_listed");
    $[358] = t;
    $[359] = t128;
  } else {
    t128 = $[359];
  }
  let t129;
  if ($[360] !== isRegularAdmin || $[361] !== regularIsActiveCheck || $[362] !== t128) {
    t129 = {
      name: t128,
      href: "/management/white-list-mailbox",
      shouldRender: isRegularAdmin,
      isActive: regularIsActiveCheck
    };
    $[360] = isRegularAdmin;
    $[361] = regularIsActiveCheck;
    $[362] = t128;
    $[363] = t129;
  } else {
    t129 = $[363];
  }
  let t130;
  if ($[364] !== t) {
    t130 = t("header.top_menu.admin.suspicious_content");
    $[364] = t;
    $[365] = t130;
  } else {
    t130 = $[365];
  }
  let t131;
  if ($[366] !== t) {
    t131 = t("header.top_menu.admin.suspicious_page_content_keywords");
    $[366] = t;
    $[367] = t131;
  } else {
    t131 = $[367];
  }
  let t132;
  if ($[368] !== isRegularAdmin || $[369] !== regularIsActiveCheck || $[370] !== t131) {
    t132 = {
      name: t131,
      href: "/management/suspicious-page-content-keyword",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[368] = isRegularAdmin;
    $[369] = regularIsActiveCheck;
    $[370] = t131;
    $[371] = t132;
  } else {
    t132 = $[371];
  }
  let t133;
  if ($[372] !== t) {
    t133 = t("header.top_menu.admin.suspicious_email_keywords");
    $[372] = t;
    $[373] = t133;
  } else {
    t133 = $[373];
  }
  let t134;
  if ($[374] !== isRegularAdmin || $[375] !== regularIsActiveCheck || $[376] !== t133) {
    t134 = {
      name: t133,
      href: "/management/suspicious-email-keyword",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[374] = isRegularAdmin;
    $[375] = regularIsActiveCheck;
    $[376] = t133;
    $[377] = t134;
  } else {
    t134 = $[377];
  }
  let t135;
  if ($[378] !== t) {
    t135 = t("header.top_menu.admin.suspicious_email_address");
    $[378] = t;
    $[379] = t135;
  } else {
    t135 = $[379];
  }
  let t136;
  if ($[380] !== isRegularAdmin || $[381] !== regularIsActiveCheck || $[382] !== t135) {
    t136 = {
      name: t135,
      href: "/management/suspicious-email-address",
      isActive: regularIsActiveCheck,
      shouldRender: isRegularAdmin
    };
    $[380] = isRegularAdmin;
    $[381] = regularIsActiveCheck;
    $[382] = t135;
    $[383] = t136;
  } else {
    t136 = $[383];
  }
  let t137;
  if ($[384] !== t132 || $[385] !== t134 || $[386] !== t136) {
    t137 = [t132, t134, t136];
    $[384] = t132;
    $[385] = t134;
    $[386] = t136;
    $[387] = t137;
  } else {
    t137 = $[387];
  }
  let t138;
  if ($[388] !== t130 || $[389] !== t137) {
    t138 = {
      name: t130,
      dropdownItems: t137
    };
    $[388] = t130;
    $[389] = t137;
    $[390] = t138;
  } else {
    t138 = $[390];
  }
  let t139;
  if ($[391] !== t) {
    t139 = t("header.top_menu.admin.statistics");
    $[391] = t;
    $[392] = t139;
  } else {
    t139 = $[392];
  }
  let t140;
  if ($[393] !== checkAdminRoles || $[394] !== isWorkspaceOwner || $[395] !== isWsAdmin) {
    t140 = (isWorkspaceOwner || isWsAdmin) && checkAdminRoles([AdminRolesEnum.superAdmin]);
    $[393] = checkAdminRoles;
    $[394] = isWorkspaceOwner;
    $[395] = isWsAdmin;
    $[396] = t140;
  } else {
    t140 = $[396];
  }
  let t141;
  if ($[397] !== regularIsActiveCheck || $[398] !== t139 || $[399] !== t140) {
    t141 = {
      name: t139,
      href: "/management/statistics",
      shouldRender: t140,
      isActive: regularIsActiveCheck
    };
    $[397] = regularIsActiveCheck;
    $[398] = t139;
    $[399] = t140;
    $[400] = t141;
  } else {
    t141 = $[400];
  }
  let t142;
  if ($[401] !== t117 || $[402] !== t120 || $[403] !== t122 || $[404] !== t125 || $[405] !== t127 || $[406] !== t129 || $[407] !== t138 || $[408] !== t141 || $[409] !== t99) {
    t142 = [t99, t117, t120, t122, t125, t127, t129, t138, t141];
    $[401] = t117;
    $[402] = t120;
    $[403] = t122;
    $[404] = t125;
    $[405] = t127;
    $[406] = t129;
    $[407] = t138;
    $[408] = t141;
    $[409] = t99;
    $[410] = t142;
  } else {
    t142 = $[410];
  }
  let t143;
  if ($[411] !== t142 || $[412] !== t97) {
    t143 = {
      name: t97,
      dropdownItems: t142,
      mobileIconRenderer: _temp10
    };
    $[411] = t142;
    $[412] = t97;
    $[413] = t143;
  } else {
    t143 = $[413];
  }
  let t144;
  if ($[414] !== t) {
    t144 = t("header.top_menu.help");
    $[414] = t;
    $[415] = t144;
  } else {
    t144 = $[415];
  }
  const t145 = user?.dashboardLocale === LocaleEnum.ENGLISH ? `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${process.env.NEXT_PUBLIC_SIO_HOST_NAME}/help` : `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${process.env.NEXT_PUBLIC_SIO_HOST_NAME}/${user?.dashboardLocale}/help`;
  let t146;
  if ($[416] === Symbol.for("react.memo_cache_sentinel")) {
    t146 = isClient() ? isSioHost(window.location.host) : false;
    $[416] = t146;
  } else {
    t146 = $[416];
  }
  let t147;
  if ($[417] !== regularIsActiveCheck || $[418] !== t144 || $[419] !== t145) {
    t147 = {
      name: t144,
      href: t145,
      target: "__blank",
      mobileIconRenderer: _temp11,
      shouldRender: t146,
      isActive: regularIsActiveCheck
    };
    $[417] = regularIsActiveCheck;
    $[418] = t144;
    $[419] = t145;
    $[420] = t147;
  } else {
    t147 = $[420];
  }
  let t148;
  if ($[421] !== t143 || $[422] !== t147 || $[423] !== t21 || $[424] !== t33 || $[425] !== t4 || $[426] !== t45 || $[427] !== t54 || $[428] !== t61 || $[429] !== t68 || $[430] !== t81 || $[431] !== t96) {
    const menuItems = [t4, t21, t33, t45, t54, t61, t68, t81, t96, t143, t147];
    t148 = {
      menuItems
    };
    $[421] = t143;
    $[422] = t147;
    $[423] = t21;
    $[424] = t33;
    $[425] = t4;
    $[426] = t45;
    $[427] = t54;
    $[428] = t61;
    $[429] = t68;
    $[430] = t81;
    $[431] = t96;
    $[432] = t148;
  } else {
    t148 = $[432];
  }
  return t148;
};
function _temp() {
  return <UpgradeIcon />;
}
function _temp2() {
  return <DashboardIcon />;
}
function _temp3() {
  return <ContactsIcon />;
}
function _temp4() {
  return <BlogsIcon />;
}
function _temp5() {
  return <EmailsIcon />;
}
function _temp6() {
  return <SmsMenuIcon />;
}
function _temp7() {
  return <AutomationsIcon />;
}
function _temp8() {
  return <ProductsIcon />;
}
function _temp9() {
  return <SalesIcon />;
}
function _temp10() {
  return <ManInSuit />;
}
function _temp11() {
  return <HelpIcon />;
}